// AppRoutes.tsx
import React from "react";
import { Route, Routes } from "react-router-dom";
import { MainLayout } from "./mainLayout";

// USER
import { LoginContainer } from '../components/login/login.container';
import { BranchAddContainer } from '../components/branch/mutation/branchAddContainer';
import { BranchEditContainer } from '../components/branch/mutation/branchEditContainer';
import { CompanyViewContainer } from '../components/company/companyView/companyViewContainer';
import { BranchViewContainer } from "../components/branch/branchView/branchViewContainer";

// LAYOUTS
import { BranchListContainer } from "../components/branch/branchList/branchListViewContainer";
import { EmployeeListByBranchContainer } from "../components/employee/employeeList/employeeListContainer";

import { EmployeeDetailsContainer } from "../components/employee/employeeDetailView/employeeDetailsContainer";
import { Breadcrumbs } from "../components/shared/Breadcrumbs";
import { Collection } from "../enums/collections.enum";
import { RatingResultsContainer } from "../components/branch/ratingResults/ratingResultsContainer";
// import HomeView from "../components/homePage/homePage";
import { CompanyEditContainer } from "../components/company/mutation/companyEditContainer";
import { EmployeeAddContainer } from "../components/employee/mutation/employeeAddContainer";
import { EmployeeEditContainer } from "../components/employee/mutation/employeeEditContainer";
import { AdminProtected } from "./AdminProtected";
import { AdminUsersListViewContainer } from "../components/admin/users/adminUsersListViewContainer";
import { ChangePasswordContainer } from "../components/changePassword/changePasswordContainer";
import { CompanyListContainer } from "../components/company/companyListViewContainer";
import { UserRoles } from "../enums/userRoles.enum";
import { CompanyAddContainer } from "../components/company/mutation/companyAddContainer";
import { OwnersListByCompanyContainer } from "../components/employee/employeeList/ownerListContainer";
import { BranchByKeyContainer } from "../components/branch/branchByKey/branchByKeyContainer";
import PromoPage from "../components/promoPage/promoPage";

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<PromoPage />} />
        <Route path="/login" element={<LoginContainer />} />
        <Route path="/change-password" element={<ChangePasswordContainer />} />

        <Route element={<AdminProtected />}>
          <Route path={`admin-users`} element={<AdminUsersListViewContainer />} />
          <Route path={`${Collection.Companies}`} element={<CompanyListContainer />} />

        </Route>

        <Route path={`${Collection.Companies}/:companyId`} element={
          <>
            <Breadcrumbs />
            <CompanyViewContainer />
            <BranchListContainer />
            <OwnersListByCompanyContainer />
          </>}>
        </Route>

        <Route path={`${Collection.Companies}/add`} element={<CompanyAddContainer />} />
        <Route path={`${Collection.Companies}/:companyId/edit`} element={<CompanyEditContainer />} />
        <Route path={`${Collection.Companies}/:companyId/${Collection.Branches}/:branchId`} element={<><Breadcrumbs /><BranchViewContainer /><EmployeeListByBranchContainer showAddEmployee /></>} />
        <Route path={`${Collection.Companies}/:companyId/${Collection.Branches}/:branchId/${Collection.Reviews}`} element={<><Breadcrumbs /><RatingResultsContainer /></>} />
        <Route path={`${Collection.Companies}/:companyId/${Collection.Branches}/add`} element={<><Breadcrumbs /><BranchAddContainer /></>} />
        <Route path={`${Collection.Companies}/:companyId/${Collection.Branches}/:branchId/edit`} element={<><Breadcrumbs /><BranchEditContainer /></>} />
        <Route path={`${Collection.Companies}/:companyId/${Collection.Branches}/:branchId/${Collection.Users}`} element={<><Breadcrumbs /><BranchAddContainer /></>} />
        <Route path={`${Collection.Companies}/:companyId/${Collection.Branches}/:branchId/${Collection.Users}/add`} element={<><Breadcrumbs /><EmployeeAddContainer userRole={UserRoles.employee} /></>} />
        <Route path={`${Collection.Companies}/:companyId/${Collection.Branches}/:branchId/${Collection.Users}/:userId`} element={<><Breadcrumbs /><EmployeeDetailsContainer /></>} />
        <Route path={`${Collection.Companies}/:companyId/${Collection.Branches}/:branchId/${Collection.Users}/:userId/edit`} element={<><Breadcrumbs /><EmployeeEditContainer /></>} />
        <Route path={`${Collection.Companies}/:companyId/${Collection.Users}/add`} element={<><Breadcrumbs /><EmployeeAddContainer userRole={UserRoles.owner} /></>} />
        <Route path={`${Collection.Companies}/:companyId/${Collection.Users}/:userId/edit`} element={<><Breadcrumbs /><EmployeeEditContainer /></>} />


        <Route path="promo" element={<PromoPage />} />
        <Route path="promo/:companyName" element={<PromoPage />} />
        <Route path={`:branchKey`} element={<BranchByKeyContainer />} />
      </Route>
    </Routes>
  );
};

